import MapGeofenceType from './MapGeofenceType'
export default MapGeofenceType;


// WEBPACK FOOTER //
// ./src/common/components/MapGeofence/MapGeofenceType/index.js